import { z } from 'zod';

// ─── Sub-schemas ──────────────────────────────────────────────────────────────

const marketSchema = z.string().min(2).max(80);
const marketsSchema = z.array(marketSchema).min(1).max(20);

const sourcePackFileRefSchema = z.object({
  id: z.string().uuid(),
  version: z.number().int().positive(),
});

// ─── Request schemas ──────────────────────────────────────────────────────────

export const CreateProductRequestSchema = z.object({
  id: z.string().min(1).max(100),
  name: z.string().min(1).max(200),
  active: z.boolean().default(true),
  markets: marketsSchema,
  sourcePackFiles: z.array(sourcePackFileRefSchema).default([]),
});
export type CreateProductRequest = z.infer<typeof CreateProductRequestSchema>;

export const UpdateProductRequestSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  active: z.boolean().optional(),
  markets: marketsSchema.optional(),
  sourcePackFiles: z.array(sourcePackFileRefSchema).optional(),
});
export type UpdateProductRequest = z.infer<typeof UpdateProductRequestSchema>;

// ─── Response schemas ─────────────────────────────────────────────────────────

export const ProductResponseSchema = z.object({
  id: z.string(),
  version: z.number().int().positive(),
  name: z.string(),
  active: z.boolean(),
  markets: z.array(z.string()),
  isCurrent: z.boolean(),
  createdAt: z.string(),
  createdBy: z.string().uuid().nullable().optional(),
});
export type ProductResponse = z.infer<typeof ProductResponseSchema>;

export const ListProductsResponseSchema = z.object({
  ok: z.literal(true),
  items: z.array(ProductResponseSchema),
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  offset: z.number().int().nonnegative(),
});
export type ListProductsResponse = z.infer<typeof ListProductsResponseSchema>;
